export class RoofType {
	public static UNKNOWN: number = -1;
	public static PANTILED: number = 0;
	//Dieser Wert wurde benutzt für Stockschrauben-iable
	public static TRAPEZOIDAL: number = 1;
	//Dieser Wert wurde benutzt für Stockschrauben-iable
	public static CORRUGATED: number = 2;
	public static SLATED: number = 3;
	public static PLAIN_TILED: number = 4;
}